/**
 * Application constants and configuration values
 * Centralized location for URLs, links, and other shared constants
 */

/**
 * Formbricks application links
 */
export const FORMBRICKS_LINKS = {
  PREMIUM_MASTERMIND_APPLICATION: "https://app.formbricks.com/s/cmhzgpid4ar49ad01bzxabwun",
} as const;

/**
 * Member portal links
 */
export const MEMBERSHIP_LINKS = {
  FREE:
    "https://members.aiforhrmastermind.com/memberships?mpid=UHJvZHVjdDozNjgwODg4NTE1NDQxMjc1OTMy&membershipPlanSlug=free-plan",
  STANDARD:
    "https://members.aiforhrmastermind.com/memberships?mpid=UHJvZHVjdDozNjk4MjczMTE2NDM5NTY3NTIw&membershipPlanSlug=ai-for-hr-mastermind-standard-303a3",
  PORTAL: "https://members.aiforhrmastermind.com/",
  MEMBERSHIPS: "https://members.aiforhrmastermind.com/memberships",
} as const;

export const STANDARD_DOWNSELL_HEADLINE = "Not ready for a live cohort?";
export const STANDARD_DOWNSELL_SUBHEAD =
  "Start self-paced with Standard. Upgrade to Premium anytime; we'll credit your remaining Standard time.";
export const STANDARD_DOWNSELL_FEATURES = [
  "The Core AI for HR Mastermind course",
  "AI Chat Platform with 6 frontier models",
  "Custom AI agents and implementation guides",
  "Monthly live workshops and recording library",
] as const;

/**
 * Optional self-paced path for people exploring membership options
 */
export const SELF_PACED_OFFER_PATH = "/self-paced" as const;

/**
 * External links and URLs used throughout the application
 */
export const EXTERNAL_LINKS = {
  PREMIUM_MASTERMIND_APPLICATION: FORMBRICKS_LINKS.PREMIUM_MASTERMIND_APPLICATION,
} as const;
